import { render, staticRenderFns } from "./MathPage.vue?vue&type=template&id=e39a4d6a&"
import script from "./MathPage.vue?vue&type=script&lang=js&"
export * from "./MathPage.vue?vue&type=script&lang=js&"
import style0 from "./MathPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports